module.exports = __webpack_public_path__ + "static/img/11.4b790f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/11.png
// module id = nbE6
// module chunks = 0